import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { API_URL } from '../../Actions/Config'
import OwlCarousel from "react-owl-carousel"
import DatePicker from "react-datepicker";
import AOS from "aos";
import Header from '../Common/Header'
import Footer from '../Common/Footer'
import Helmet from '../Common/Helmet'
import TourListing from "../Common/TourListing"
import { getTransferDetails, checkAmount } from "../../Actions/TourDetailsAction"
import { handleVehicleBooking } from "../../Actions/CheckoutAction"
import { tourFb, tourTw, tourLn } from "../../Images"
import "aos/dist/aos.css";
import "../../css/mainUpdate.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-datepicker/dist/react-datepicker.css";

const mapStateToProps = (state) => {
    return {
        tourDetailsReducer: state.TourDetailsReducer,
        CheckoutReducer: state.CheckoutReducer
    }
}

const mapDispatchToProps = dispatch => ({
    getTransferDetails: () => dispatch(getTransferDetails()),
    checkAmount: (data) => dispatch(checkAmount(data)),
    handleVehicleBooking: (data) => dispatch(handleVehicleBooking(data))
});


function getURL(permalink) {
    var url = ""
    url = "/transport/" + permalink
    return url
}

function getImageURL(url, type = 0) {
    var image = ""

    switch (type) {
        case 0:
            image = API_URL + "/" + url
            break;

        default:
            break;
    }

    return image
}

class Transfers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            vehicle_description: "",
            vehicle: null,
            vehicle_id: 0,
            from: "",
            to: "",
            max: 1,
            num_person: 1,
            price: 0
        }
        this.props.getTransferDetails()
    }

    componentDidMount() {
        const savedState = sessionStorage.getItem("vehicleState");
        if (savedState) {
            const state = JSON.parse(savedState);

            if (state.date) {
            state.date = new Date(state.date);
            }
            this.setState(state);
        }
    }

    componentDidUpdate() {
        const savedState = sessionStorage.getItem("vehicleState");
        if (this.state.price != this.props.tourDetailsReducer.transportCost && !savedState) {
            this.setState({
                price: this.props.tourDetailsReducer.transportCost
            })
        }
    }

    handleDateChange = (value) => {
        this.setState({
            date: value
        });
    }

    handleVehichType = (type) => {
        this.setState({
            vehicle_description: type.vehicle_description,
            vehicle: type,
            vehicle_id: type.id,
            max: type.max_passengers,
            num_person: 1
        }, () => this.handleAmount())
    }

    handleAmount = () => {
        if (this.state.from == "" || this.state.to == "" || this.state.vehicle_id == 0) {
            return false
        }
        this.props.checkAmount({
            fromcity_id: this.state.from,
            tocity_id: this.state.to,
            type: this.state.vehicle_id,
        })
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        }, () => this.handleAmount());
    }

    handlePlusPerson = (type) => {
        if (type == "plus") {
            if ((this.state.num_person) == this.state.max) {
                return false
            } else {
                this.setState({
                    num_person: this.state.num_person + 1
                })
            }
        } else {
            if ((this.state.num_person - 1) < 1) {
                return false
            } else {

                this.setState({
                    num_person: this.state.num_person - 1
                })
            }
        }
    }

    handleBooking = () => {
        const { from, to, vehicle, price } = this.state
        if (from == "" || to == "" || vehicle == null || price == 0) {
            return false
        }
        sessionStorage.setItem(
            "vehicleState",
            JSON.stringify(this.state)
        );

        this.props.handleVehicleBooking({
            date: this.state.date.toLocaleDateString('en-GB'),
            from: this.props.tourDetailsReducer.city.find((city) => city.id == this.state.from),
            to: this.props.tourDetailsReducer.city.find((city) => city.id == this.state.to),
            num_person: this.state.num_person,
            vehicle: this.state.vehicle,
            price: this.state.price
        })
        
        setTimeout(() => {
            this.props.history.push("/vehicle-transfers/confirm-reserve")
        }, 1000);
    }

    render() {

        const { transports, city, transfer, types } = this.props.tourDetailsReducer;
        var state = this.state

        return <Fragment>
            <Header home={false} />
            <Helmet
                title={"Tour List"}
                description={"Listing"}
            />
            <div className='tour-details'>
                {transfer ?
                    <div id='main-container' class="transport-page">

                        <div className="page-title">
                            <div className="container title-cont">
                                <div className="row">
                                    <div className="col-lg-12 title-inner tour-details-breadcrumb">
                                        <div className="breadcrumb-links">
                                            <a href="/">Home</a>
                                            <span className="sep"></span>
                                            <a href="#">Transport </a>
                                            <span className="sep"></span>
                                            <a>Transfers</a>
                                        </div>
                                        <h1>Transfers </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="contentwrap">
                            <div className="introwrap">
                                <div className="tour-content-wrap">
                                    <div className='container'>
                                        <div className='row'>
                                            <div class="transfers-content col-lg-9">
                                                <div class="transfers-block">
                                                    <span class="stepno">1</span>
                                                    <h4>Add your Trip Details</h4>
                                                    <div class="tb-title-caption">Transfers page cost is loaded from route costing entered for each vehicle type</div>

                                                    <div class="tb-field" style={{ width: "100%" }}>
                                                        <div style={{ float: "Left", width: "40%" }}>
                                                            <label>From</label>
                                                            <select id="fromcity_id" name="fromcity_id" class="form-control" value={this.state.from} name="from" onChange={this.handleChange}>
                                                                <option value="" selected disabled hidden>City</option>
                                                                {city.length > 0 ? city.map((from) => (
                                                                    <option value={from.id}>{from.name == "Katunayake" ? "Airport (BIA)" : from.name}</option>
                                                                )) : null}
                                                            </select>
                                                        </div>
                                                        <div style={{ float: "Left", padding: 20 }}>  </div>
                                                        <div style={{ float: "Left", width: "40%" }}>
                                                            <label>To</label>
                                                            <select id="tocity_id" name="tocity_id" class="form-control" value={this.state.to} name="to" onChange={this.handleChange}>
                                                                <option value="" selected disabled hidden>City</option>
                                                                {city.length > 0 ? city.map((to) => (
                                                                    <option value={to.id}>{to.name == "Katunayake" ? "Airport (BIA)" : to.name}</option>
                                                                )) : null}
                                                            </select>

                                                        </div>
                                                    </div>
                                                    <input type="hidden" name="route_id" value="0" class="route_select" />

                                                    <div class="clear"></div>
                                                </div>

                                                <div class="transfers-block vehicle-type">
                                                    <span class="stepno">2</span>
                                                    <h4>Vehicle Type & Number of person</h4>
                                                    <div class="tb-title-caption">Transfers page cost is loaded from route costing entered for each vehicle type</div>

                                                    <div class="tb-field">
                                                        <label>Vehicle Type</label>
                                                        <div class="vt-block">
                                                            {types.length > 0 ? types.map((type) => (
                                                                <div onClick={() => this.handleVehichType(type)}>
                                                                    <span class={"vt-item car" + (type.id == state.vehicle_id ? " active" : "")}>{type.type}
                                                                        <img src={getImageURL(type.vehicle_icon)} />
                                                                    </span>
                                                                </div>
                                                            )) : null}
                                                        </div>
                                                    </div>

                                                    <div class="tb-field">
                                                        <label class="label-nop">Number of Person</label>
                                                        <div class="nop-block">
                                                            <input type="text" class="text txt-tranfers txt-nop" value={this.state.num_person} max={this.state.max} />
                                                            <span class="nop-plusminus nop-plus" onClick={() => this.handlePlusPerson("plus")}></span>
                                                            <span class="nop-plusminus nop-minus" onClick={() => this.handlePlusPerson("minus")}></span>
                                                        </div>
                                                        <div class="vhitrf"> <label> Vehicle Description</label>
                                                            <div style={{ width: 350, height: 150, backgroundColor: "none", overFlowY: "auto" }} class="vehicle_description">
                                                                <div
                                                                    dangerouslySetInnerHTML={{ __html: state.vehicle_description }}
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="clear"></div>
                                                </div>



                                                <div class="summery col-po-12">
                                                    <h2>Book Now</h2>
                                                    <p>Transfer package calculation will be, number of Kms x rate per Km</p>

                                                    <div style={{ width: 300, paddingBottom: 50 }} class="date input-group start_transport_date ">

                                                        <DatePicker
                                                            selected={state.date}
                                                            onChange={(date) => this.handleDateChange(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            minDate={new Date}
                                                        />

                                                        <span class="input-group-addon"><span style={{ display: "none" }} class="glyphicon glyphicon-th"></span></span>
                                                    </div>
                                                </div>

                                                <div class="car-prz col-po-12" >
                                                    <p style={{ fontFamily: "circular-std-bold!important" }}>Total</p>
                                                    <h1 style={{ fontFamily: "circular-std-bold!important" }}>   <div id="finalrate">USD ${Number(state.price).toFixed(2)} </div></h1>

                                                    <button onClick={this.handleBooking} class="button  btn-blue pull-right btn-arrow-next btn-lg btn-block  trans_book test" id="triggerproceedbtn">Book Now <span class="glyphicon glyphicon-chevron-right"> </span></button>
                                                </div>

                                            </div>
                                            <div class="col-lg-3">
                                                {transports.length > 0 ? transports.slice(0, 3).map((transport) => (<a href={getURL(transport.permalink)}>
                                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-po-12">
                                                        <div class="car-lis">
                                                            <img src={getImageURL(transport.package_thumbnail)} width="262" height="139" />
                                                            <div class="pack-name">
                                                                <h5>Package Name</h5>
                                                                <p>{transport.vehicle_type.type}</p>
                                                            </div>
                                                            <div class="car-lis-det">
                                                                <img src={getImageURL('assets/website/images/man.png')} width="16" height="17" />
                                                                <div>
                                                                    <h5>Number of People</h5>
                                                                    <p>{transport.vehicle_type.max_passengers}</p>
                                                                </div>
                                                            </div>
                                                            <div class="car-lis-det mis-allo">
                                                                <img src={getImageURL('assets/website/images/doller.png')} width="18" height="19" />
                                                                <div>
                                                                    <h5>Mileage Allocation</h5>
                                                                    <p>{transport.allocated_mileage}</p>
                                                                </div>
                                                            </div>
                                                            <div class="car-lis-det mis-allo">
                                                                <img src={getImageURL('assets/website/images/doller.png')} width="18" height="19" />
                                                                <div>
                                                                    <h5>Cost Per Day</h5>
                                                                    <p>Rs. {transport.cost_per_day}</p>
                                                                </div>
                                                            </div>
                                                            <span class="right-dth"></span>
                                                        </div>
                                                    </div>
                                                </a>)) : null}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null}
            </div>
            <Footer hyperLink={true} />
        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps),withRouter)(Transfers);